// User language and other locale settings
import {getCookie} from './cookie';

function getLanguage() {
    if (getCookie('django_language') !== '') {
        return getCookie('django_language');
    }

    return location.pathname.split('/')[1];
}


export const USER_LANG = getLanguage(); // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/utils/locale.js